"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/PosterPlus/components/Display.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_audioThumbnail = require("./../assets/audio-thumbnail.png"),
    audioThumbnail = module_audioThumbnail.default || module_audioThumbnail,
    module_videoThumbnail = require("./../assets/video-thumbnail.jpeg"),
    videoThumbnail = module_videoThumbnail.default || module_videoThumbnail,
    module_unknownThumbnail = require("./../assets/unknown-thumbnail.png"),
    unknownThumbnail = module_unknownThumbnail.default || module_unknownThumbnail,
    module_documentThumbnail = require("./../assets/document-thumbnail.png"),
    documentThumbnail = module_documentThumbnail.default || module_documentThumbnail,
    Image_template = require("../../Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Locale_template = require("../../Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_attrs0 = {
        "class": "text-center border rounded"
      },
    marko_attrs1 = {
        "class": "text-center border rounded"
      },
    marko_attrs2 = {
        "class": "w-100 h-100 d-flex align-items-center justify-content-center"
      },
    marko_attrs3 = {
        "class": "text-center border rounded"
      },
    marko_attrs4 = {
        "class": "w-100 h-100 d-flex align-items-center justify-content-center"
      },
    marko_attrs5 = {
        "class": "h-100 d-flex align-items-center justify-content-center"
      },
    marko_attrs6 = {
        "class": "h-100 d-flex align-items-center justify-content-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("f384cb"),
    marko_node0 = marko_createElement("br", null, "15", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "py-1"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if ((input.mime || "").includes("image") || /\.(png|jp(e?)g|webp|gif)/.test(input.src)) {
    if (input.mode == "thumbnail") {
      out.be("div", marko_attrs0, "0", component);

      Image_tag({
          alt: "Image",
          src: input.src,
          class: "img-fluid"
        }, out, __component, "1");

      out.ee();
    } else {
      Image_tag({
          alt: "Image",
          class: "workspace-element",
          src: input.src,
          style: {
              width: input.width || "auto",
              height: input.height || "auto",
              maxWidth: "100%",
              maxHeight: "100%",
              margin: "auto"
            }
        }, out, __component, "2");
    }
  } else if ((input.mime || "").includes("video") || /\.(mp4|webm)$/.test(input.src)) {
    if (input.mode == "thumbnail") {
      out.e("div", marko_attrs1, "3", component, 1)
        .e("img", {
            src: videoThumbnail,
            "class": "img-fluid"
          }, "4", component, 0);
    } else {
      out.e("div", marko_attrs2, "5", component, 1)
        .e("video", {
            src: input.src,
            controls: true,
            "class": "w-100"
          }, "6", component, 0);
    }
  } else if ((input.mime || "").includes("audio") || /\.(mp3|mpeg|wave)$/.test(input.src)) {
    if (input.mode == "thumbnail") {
      out.e("div", marko_attrs3, "7", component, 1)
        .e("img", {
            src: audioThumbnail,
            "class": "img-fluid w-75",
            style: "padding:8px 0"
          }, "8", component, 0);
    } else {
      out.e("div", marko_attrs4, "9", component, 1)
        .e("audio", {
            src: input.src,
            controls: true,
            "class": "w-100"
          }, "10", component, 0);
    }
  } else if ((input.mime || "").includes("application") && /(pdf|doc(x?)|txt|ppt(x?)|xlsx|epub|mobi|kindle|htm(l?))/.test(input.mime)) {
    out.e("div", marko_attrs5, "11", component, 1)
      .e("img", {
          src: documentThumbnail,
          "class": "img-fluid w-75"
        }, "12", component, 0);
  } else {
    out.be("div", marko_attrs6, "13", component);

    out.e("img", {
        src: unknownThumbnail,
        "class": "img-fluid w-75"
      }, "14", component, 0);

    out.n(marko_node0, component);

    out.be("div", marko_attrs7, "16", component);

    Locale_tag({
        renderBody: function(out) {
          out.t("Unknown File Type");
        }
      }, out, __component, "17");

    out.ee();

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
